module.exports = __webpack_public_path__ + "static/media/cable_2.1432fcd8.svg";